import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);
const Login = resolve => require(['@/Login'], resolve);
const Index = resolve => require(['@/views/Index'], resolve);
const WorkerBrnch = resolve => require(['@/views/workbench'], resolve);
const CustomerManagement = resolve => require(['@/views/customer/CustomerManagement'], resolve);
const AddCustomers = resolve => require(['@/views/customer/AddCustomers'], resolve);
const Contract = resolve => require(['@/views/customer/Contract'], resolve);
const AddContract = resolve => require(['@/views/customer/AddContract'], resolve);
const DetailsContract = resolve => require(['@/views/customer/DetailsContract'], resolve);
const CupboardManagement = resolve => require(['@/views/cupboard/CupboardManagement'], resolve);
const Cabinet = resolve => require(['@/views/cupboard/Cabinet'], resolve);
const AddnewCupboard = resolve => require(['@/views/cupboard/AddnewCupboard'], resolve);
const ModifyCupboard = resolve => require(['@/views/cupboard/ModifyCupboard'], resolve);
const CommodityManagement = resolve => require(['@/views/commodity/CommodityManagement'], resolve);
const warehouse = resolve => require(['@/views/commodity/warehouse'], resolve);
const modifyWarehourse = resolve => require(['@/views/commodity/modifyWarehourse'], resolve);
const AddCommodity = resolve => require(['@/views/commodity/AddCommodity'], resolve);
const ModifyCommodity = resolve => require(['@/views/commodity/ModifyCommodity'], resolve);
const ClassifyManagement = resolve => require(['@/views/commodity/ClassifyManagement'], resolve);
const AddClassify = resolve => require(['@/views/commodity/AddClassify'], resolve);
const ModifyClassify = resolve => require(['@/views/commodity/ModifyClassify'], resolve);
const ModifyTwoClassify = resolve => require(['@/views/commodity/ModifyTwoClassify'], resolve);
const Employee = resolve => require(['@/views/employee/Employee'], resolve);
const AddEmployee = resolve => require(['@/views/employee/AddEmployee'], resolve);
const ModifyEmployee = resolve => require(['@/views/employee/ModifyEmployee'], resolve);
const withdraw = resolve => require(['@/views/finance/withdraw'], resolve);
const withdrawDetail = resolve => require(['@/views/finance/withdrawDetail'], resolve);
const checkwithdraw = resolve => require(['@/views/finance/checkwithdraw'], resolve);
const commercial = resolve => require(['@/views/finance/commercial'], resolve);
const commercialDetail = resolve => require(['@/views/finance/commercialDetail'], resolve);
const account = resolve => require(['@/views/finance/account'], resolve);
// const checkcommercial = resolve => require(['@/views/finance/checkcommercial'], resolve);
//1.5
//意见反馈
const suggestion = resolve => require(['@/views/suggest/suggestion'], resolve);
const suggestList = resolve => require(['@/views/suggest/suggestList'], resolve);
const reportFailure = resolve => require(['@/views/suggest/reportFailure'], resolve);
const failureDetail = resolve => require(['@/views/suggest/failureDetail'], resolve);

//  合同变更
const ModifyContract = resolve => require(['@/views/customer/ModifyContract'], resolve);
const ContractList = resolve => require(['@/views/customer/ContractList'], resolve);

const ModifyCustomer = resolve => require(['@/views/customer/ModifyCustomer'], resolve);
const checkCup = resolve => require(['@/views/cupboard/checkCup'], resolve);
const CustomerDetail = resolve => require(['@/views/customer/CustomerDetail'], resolve);
const contractDetail = resolve => require(['@/views/customer/contractDetail'], resolve);
const contractDetails = resolve => require(['@/views/customer/contractDetails'], resolve);
const contractDetailss = resolve => require(['@/views/customer/contractDetailss'], resolve);
const contractexpand = resolve => require(['@/views/customer/contractexpand'], resolve);


//升级提示
const android = resolve => require(['@/views/upload/android'], resolve);
const updateandroid = resolve => require(['@/views/upload/updateandroid'], resolve);
const upload = resolve => require(['@/views/upload/upload'], resolve);
const uploadrecord = resolve => require(['@/views/upload/uploadrecord'], resolve);
const uploadinterface = resolve => require(['@/views/upload/uploadinterface'], resolve);
const upgrade = resolve => require(['@/views/upload/upgrade'], resolve);
const versionupload = resolve => require(['@/views/upload/versionupload'], resolve);
const associator = resolve => require(['@/views/suggest/associator'], resolve);
const associatorDetail = resolve => require(['@/views/suggest/associatorDetail'], resolve);
const clearRecord = resolve => require(['@/views/suggest/clearRecord'], resolve);

// const Employee = resolve => require(['@/views/employee/Employee'], resolve);

//腰封列表
const girdleManagement = resolve => require(['@/views/cupboard/girdleManagement'], resolve);
const checkGridle = resolve => require(['@/views/cupboard/checkGridle'], resolve);
//故障列表
const faultManagement = resolve => require(['@/views/cupboard/faultManagement'], resolve);
const faultDetail = resolve => require(['@/views/cupboard/faultDetail'], resolve);
//文档列表
const docManagement = resolve => require(['@/views/document/docManagement'], resolve);
const docManage = resolve => require(['@/views/document/docManage'], resolve);
const modifyDoc = resolve => require(['@/views/document/modifyDoc'], resolve);

//激活列表
const activaction = resolve => require(['@/views/document/activaction'], resolve);
//公告管理
const noticeManagement = resolve => require(['@/views/document/noticeManagement'], resolve);
const modifyNotice = resolve => require(['@/views/document/modifyNotice'], resolve);
const Test = resolve => require(['@/Test'], resolve)
const NotFour = resolve => require(['@/views/Error-404'], resolve)
//检测管理
const testing = resolve => require(['@/views/document/testing'], resolve)
const testingDetail = resolve => require(['@/views/document/testingDetail'], resolve)
//版本管理
const editionManagement = resolve => require(['@/views/document/editionManagement'],resolve)
//识别模型
const model = resolve => require(['@/views/model/modelList'], resolve)
const modelUpdate = resolve => require(['@/views/model/modelUpdate'], resolve)
const trainDetail = resolve => require(['@/views/model/trainDetail'], resolve)
const train = resolve => require(['@/views/model/train'], resolve)
const sellerModel = resolve => require(['@/views/model/sellerModel'], resolve)
const sampleLibrary = resolve => require(['@/views/model/sampleLibrary'], resolve)
const samplePicture = resolve => require(['@/views/model/samplePicture'], resolve)
const sampleRate = resolve => require(['@/views/model/sampleRate'], resolve)

//拓元商品库
const openVersion = resolve => require(['@/views/commodity/openVersion'], resolve)
const AddopenVersion = resolve => require(['@/views/commodity/AddopenVersion'], resolve)

//三方识别对比
const identify = resolve => require(['@/views/commodity/identify'], resolve)

const thirdManagement = resolve => require(['@/views/customer/thirdManagement'],resolve)
const modifyThird = resolve => require(['@/views/customer/modifyThird'],resolve)
const voucher = resolve => require(['@/views/customer/voucher'],resolve)
const addVocher = resolve => require(['@/views/customer/addVocher'],resolve)

//工单管理
const work = resolve => require(['@/views/work/work'],resolve)
const repair = resolve => require(['@/views/work/repair'],resolve)
const repairdetail = resolve => require(['@/views/work/repairdetail'],resolve)
const router = new VueRouter({
  mode: 'history',
  routes: [{
      path: "/",
      name: "login",
      component: Login
    },
    {
      path: "/login",
      component: Login
    },
    {
      path: "/index",
      name: "index",
      component: Index,
      redirect: '/index/workbrnch',
      children: [{
          path: 'workbrnch',
          name: 'workbrnch',
          component: WorkerBrnch
        },
        {
          path: 'customerManagement',
          name: 'customerManagement',
          component: CustomerManagement,
        },
        {
          path: 'addcustomers',
          name: 'addcustomers',
          component: AddCustomers
        },
        {
          path: 'contract',
          name: 'contract',
          component: Contract
        },
        {
          path: 'addcontract',
          name: 'addcontract',
          component: AddContract
        },
        {
          path: 'CupboardManagement',
          name: 'CupboardManagement',
          component: CupboardManagement
        },
        {
          path: 'Cabinet',
          name: 'Cabinet',
          component: Cabinet
        },
        {
          path: 'AddnewCupboard',
          name: 'AddnewCupboard',
          component: AddnewCupboard
        },
        {
          path: 'ModifyContract',
          name: 'ModifyContract',
          component: ModifyContract
        },
        {
          path: 'ContractList',
          name: 'ContractList',
          component: ContractList
        },
        {
          path: 'ModifyCupboard',
          name: 'ModifyCupboard',
          component: ModifyCupboard
        },
        {
          path: 'CommodityManagement',
          name: 'CommodityManagement',
          component: CommodityManagement
        },
        {
          path: 'AddCommodity',
          name: 'AddCommodity',
          component: AddCommodity
        },
        {
          path: 'ModifyCommodity',
          name: 'ModifyCommodity',
          component: ModifyCommodity
        },
        {
          path: 'ClassifyManagement',
          name: 'ClassifyManagement',
          component: ClassifyManagement
        },
        {
          path: 'AddClassify',
          name: 'AddClassify',
          component: AddClassify
        },
        {
          path: 'ModifyClassify',
          name: 'ModifyClassify',
          component: ModifyClassify
        },
        {
          path: 'warehouse',
          name: 'warehouse',
          component: warehouse
        },
        {
          path: 'modifyWarehourse',
          name: 'modifyWarehourse',
          component: modifyWarehourse
        },
        {
          path: 'ModifyTwoClassify',
          name: 'ModifyTwoClassify',
          component: ModifyTwoClassify
        },
        {
          path: 'Employee',
          name: 'Employee',
          component: Employee
        },
        {
          path: 'AddEmployee',
          name: 'AddEmployee',
          component: AddEmployee
        },
        {
          path: 'ModifyEmployee',
          name: 'ModifyEmployee',
          component: ModifyEmployee
        },
        {
          path: 'DetailsContract',
          name: 'DetailsContract',
          component: DetailsContract
        },
        {
          path: 'withdraw',
          name: 'withdraw',
          component: withdraw
        },
        {
          path: 'withdrawDetail',
          name: 'withdrawDetail',
          component: withdrawDetail
        },
        {
          path: 'checkwithdraw',
          name: 'checkwithdraw',
          component: checkwithdraw
        },
        {
          path: 'suggestion',
          name: 'suggestion',
          component: suggestion
        },
        {
          path: 'suggestList',
          name: 'suggestList',
          component: suggestList
        },
        {
          path: 'reportFailure',
          name: 'reportFailure',
          component: reportFailure
        },
        {
          path: 'failureDetail',
          name: 'failureDetail',
          component: failureDetail
        },
        {
          path: 'ModifyCustomer',
          name: 'ModifyCustomer',
          component: ModifyCustomer
        },
        {
          path: 'checkCup',
          name: 'checkCup',
          component: checkCup
        },
        {
          path: 'CustomerDetail',
          name: 'CustomerDetail',
          component: CustomerDetail
        },
        {
          path: 'contractDetail',
          name: 'contractDetail',
          component: contractDetail
        },
        {
          path: 'contractDetails',
          name: 'contractDetails',
          component: contractDetails
        },
        {
          path: 'contractDetailss',
          name: 'contractDetailss',
          component: contractDetailss
        },
        {
          path: 'contractexpand',
          name: 'contractexpand',
          component: contractexpand
        },
        {
          path: 'android',
          name: 'android',
          component: android
        },
        {
          path: 'updateandroid',
          name: 'updateandroid',
          component: updateandroid
        },
        {
          path: 'upload',
          name: 'upload',
          component: upload
        },
        {
          path: 'uploadrecord',
          name: 'uploadrecord',
          component: uploadrecord
        },
        {
          path: 'uploadinterface',
          name: 'uploadinterface',
          component: uploadinterface
        },
        {
          path: 'upgrade',
          name: 'upgrade',
          component: upgrade
        },
        {
          path: 'versionupload',
          name: 'versionupload',
          component: versionupload
        },
        {
          path: 'commercial',
          name: 'commercial',
          component: commercial
        },
        {
          path: 'commercialDetail',
          name: 'commercialDetail',
          component: commercialDetail
        },
        {
          path: 'account',
          name: 'account',
          component: account
        },
        // {
        //     path: 'checkcommercial',
        //     name: 'checkcommercial',
        //     component: checkcommercial
        // }
        {
          path: 'clearRecord',
          name: 'clearRecord',
          component: clearRecord
        },
        {
          path: 'associator',
          name: 'associator',
          component: associator
        },
        {
          path: 'associatorDetail',
          name: 'associatorDetail',
          component: associatorDetail
        },
        {
          path: 'girdleManagement',
          name: 'girdleManagement',
          component: girdleManagement
        },
        {
          path: 'faultManagement',
          name: 'faultManagement',
          component: faultManagement
        },
        {
          path: 'faultDetail',
          name: 'faultDetail',
          component: faultDetail
        },
        {
          path: 'checkGridle',
          name: 'checkGridle',
          component: checkGridle
        },
        {
          path: 'docManagement',
          name: 'docManagement',
          component: docManagement
        },
        {
          path: 'editionManagement',
          name: 'editionManagement',
          component: editionManagement
        },
        {
          path: 'docManage',
          name: 'docManage',
          component: docManage
        },
        {
          path: 'modifyDoc',
          name: 'modifyDoc',
          component: modifyDoc
        },
        {
          path: 'noticeManagement',
          name: 'noticeManagement',
          component: noticeManagement
        },
        {
          path: 'modifyNotice',
          name: 'modifyNotice',
          component: modifyNotice
        },
        {
          path: 'activaction',
          name: 'activaction',
          component: activaction
        },
        {
          path: 'testing',
          name: 'testing',
          component: testing
        },
        {
          path: 'testingDetail',
          name: 'testingDetail',
          component: testingDetail
        },
        {
          path: 'model',
          name: 'model',
          component: model
        },
        {
          path: 'modelUpdate',
          name: 'modelUpdate',
          component: modelUpdate
        },
        {
          path: 'sellerModel',
          name: 'sellerModel',
          component: sellerModel
        },
        {
          path: 'train',
          name: 'train',
          component: train
        },
        {
          path: 'trainDetail',
          name: 'trainDetail',
          component: trainDetail
        },
        {
          path: 'sampleLibrary',
          name: 'sampleLibrary',
          component: sampleLibrary
        },
        {
          path: 'samplePicture',
          name: 'samplePicture',
          component: samplePicture
        },
        {
          path: 'sampleRate',
          name: 'sampleRate',
          component: sampleRate
        },
        {
          path: 'openVersion',
          name: 'openVersion',
          component: openVersion
        },
        {
          path: 'identify',
          name: 'identify',
          component: identify
        },
        {
          path: 'AddopenVersion',
          name: 'AddopenVersion',
          component: AddopenVersion
        },
        {
          path: 'thirdManagement',
          name: 'thirdManagement',
          component: thirdManagement
        },
        {
          path: 'modifyThird',
          name: 'modifyThird',
          component: modifyThird
        },
        {
          path: 'voucher',
          name: 'voucher',
          component: voucher
        },
        {
          path: 'addVocher',
          name: 'addVocher',
          component: addVocher
        },
        {
          path: 'work',
          name: 'work',
          component: work
        },
        {
          path: 'repair',
          name: 'repair',
          component: repair
        },
        {
          path: 'repairdetail',
          name: 'repairdetail',
          component: repairdetail
        },
      ]
    },
    {
      path: '/test',
      name: 'test',
      component: Test
    },
    {
      path: '*',
      name: 'NotFour-404',
      component: NotFour
    }
  ]
});
router.beforeEach((to, from, next) => {
  // ...
  /*var userInfo = window.localStorage.getItem('token');//获取浏览器缓存的用户信息
  if(userInfo){ //如果有就直接到首页咯
    next();
  } else {
    if(to.path=='/login'){ //如果是登录页面路径，就直接next()
      next();
    } else { //不然就跳转到登录；
      next('/login');
    }
  }*/
  next()


})
export default router